import { ControllerConnectedMessage, ControllerDisconnectedMessage, ControllerMovedMessage } from "../../messages/controller/ControllerMessages";
import { busService } from "../bus";
import { MulticastDelegate1 } from "flavr-common";
import { Vector3, Quaternion } from "flavr-math";
class XRControllerService {
    constructor() {
        this.connection = busService.connection("ScriptController");
        this.controllers = new Map();
        this.onConnectDelegate = new MulticastDelegate1();
        this.onDisconnectDelegate = new MulticastDelegate1();
        this.handleControllerConnectedMessage = (msg) => {
            let data = this.controllers.get(msg.uid);
            if (!data) {
                data = {
                    uid: msg.uid,
                    hand: msg.hand,
                    isTransformValid: false,
                    transform: {
                        position: new Vector3(),
                        linearVelocity: new Vector3(),
                        orientation: new Quaternion(),
                        scale: new Vector3(1, 1, 1)
                    },
                    type: msg.controllerType
                };
                this.controllers.set(msg.uid, data);
                this.onConnectDelegate.invoke(data);
                return;
            }
            data.hand = msg.hand;
        };
        this.handleControllerDisconnectedMessage = (msg) => {
            const data = this.controllers.get(msg.uid);
            if (!data)
                return;
            this.controllers.delete(msg.uid);
            this.onDisconnectDelegate.invoke(data);
        };
        this.handleControllerMovedMessage = (msg) => {
            const data = this.controllers.get(msg.uid);
            if (!data)
                return;
            data.isTransformValid = true;
            data.transform.position.fromArray(msg.position);
            data.transform.orientation.fromArray(msg.orientation);
            data.transform.scale.setScalar(msg.scale);
            data.transform.linearVelocity.fromArray(msg.linearVelocity);
        };
        this.connection.subscribeByType(ControllerMovedMessage, this.handleControllerMovedMessage);
        this.connection.subscribeByType(ControllerConnectedMessage, this.handleControllerConnectedMessage);
        this.connection.subscribeByType(ControllerDisconnectedMessage, this.handleControllerDisconnectedMessage);
    }
    getControllerData(uid) {
        return this.controllers.get(uid);
    }
    getControllers() {
        return [...this.controllers.values()];
    }
}
export const xrControllerService = new XRControllerService();
